import type { MessageAttachmentInput } from '../types/messages';

export const MESSAGE_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;

const ALLOWED_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/gif',
  'application/pdf',
]);

export function messageAttachmentTypeError(file: { type: string; size: number }): string | null {
  if (!ALLOWED_TYPES.has(file.type)) {
    return 'Attach a JPEG, PNG, WebP, GIF, or PDF.';
  }
  if (file.size <= 0) return 'That file is empty.';
  if (file.size > MESSAGE_ATTACHMENT_MAX_BYTES) {
    return 'Attachment must be smaller than 5 MB.';
  }
  return null;
}

export function readMessageAttachment(file: File): Promise<MessageAttachmentInput> {
  const error = messageAttachmentTypeError(file);
  if (error) return Promise.reject(new Error(error));
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const data = result.includes(',') ? result.split(',')[1] : result;
      resolve({ name: file.name, contentType: file.type, data });
    };
    reader.onerror = () => reject(new Error('Could not read that file.'));
    reader.readAsDataURL(file);
  });
}

export function messageListPreview(body: string, attachmentName?: string | null): string {
  const text = body.trim();
  if (text) return text;
  if (attachmentName?.trim()) return `Attachment: ${attachmentName.trim()}`;
  return '';
}
